/* stylelint-disable scss/no-global-function-names, function-no-unknown */
@import '../../global/utility/full-width';

ui-cms-text-media {
  display: block;
  container-type: inline-size;

  @container (max-width: 350px) {
    .content {
      grid-template-columns: 1fr;

      &-media--xsmall {
        grid-template-columns: 1fr;

        .richtext {
          &-columns {
            &--2 {
              column-count: 1;
            }
          }
        }
      }
    }
  }

  @container (min-width: 360px) {
    .content {
      grid-template-columns: 1fr;

      &-media--xsmall {
        grid-template-columns: 1fr 3fr;

        .richtext {
          &-columns {
            &--2 {
              column-count: 1;
            }
          }
        }
      }
    }

    .richtext {
      &-columns {
        &--2 {
          column-count: 1;
        }
      }
    }
  }

  @container (min-width: 500px) {
    .content {
      grid-template-columns: 1fr;

      &-media--xsmall {
        grid-template-columns: 1fr 3fr;

        .richtext {
          &-columns {
            &--2 {
              column-count: 1;
            }
          }
        }
      }

      &-media--small,
      &-media--medium,
      &-media--large,
      &-media--full {
        .richtext {
          &-columns {
            &--2 {
              column-count: 2;
            }
          }
        }
      }
    }
  }

  @container (min-width: 750px) {
    .content {
      &-media--xsmall {
        grid-template-columns: 1fr 3fr;
      }

      &-media--small {
        grid-template-columns: 1fr 2fr;

        .richtext {
          &-columns {
            &--2 {
              column-count: 1;
            }
          }
        }
      }

      &-media--medium {
        grid-template-columns: 1fr 1fr;

        .richtext {
          &-columns {
            &--2 {
              column-count: 1;
            }
          }
        }
      }

      &-media--large,
      &-media--full {
        .richtext {
          &-columns {
            &--2 {
              column-count: 2;
            }
          }
        }
      }
    }
  }

  @container (min-width: 1000px) {
    .richtext {
      &-columns {
        &--2 {
          column-count: 2;
        }
      }
    }

    .content {
      &-media--small,
      &-media--medium {
        .richtext {
          &-columns {
            &--2 {
              column-count: 2;
            }
          }
        }
      }
    }
  }

  @media (min-width: 700px) {
    @container (min-width: 360px) {
      .content-media--xsmall {
        grid-template-columns: 1fr 3fr;

        &.content--text-first {
          grid-template-columns: 3fr 1fr;
        }
      }
    }
  }

  .text-media {
    display: block;
    container-type: inline-size;
  }

  .content {
    display: grid;
    row-gap: $sd-spacing-4;
    column-gap: $sd-spacing-8;

    &--vertical-align {
      align-items: center;
    }

    &-media--large {
      grid-template-columns: 1fr;
    }

    &-media--full {
      .media.media-moving-image {
        @include full-width;
      }

      .media {
        ui-cms-video,
        ui-cms-image {
          @include full-width;
        }
      }
    }

    &--text-first {
      &.content-media--xsmall {
        grid-template-columns: 3fr 1fr;
      }

      @container (min-width: 750px) {
        &.content-media--small {
          grid-template-columns: 2fr 1fr;
        }

        &.content-media--medium {
          grid-template-columns: 1fr 1fr;
        }
      }
    }
  }

  .richtext {
    display: flex;
    flex-direction: column;
    gap: $sd-spacing-6;

    &-columns {
      &--1 {
        column-count: 1;
      }
    }

    .sd-list--icon {
      list-style: none;
      padding-left: 0;

      > li {
        padding-left: $sd-spacing-10;
      }
    }
  }

  .image {
    position: relative;

    &--lightbox {
      sd-button {
        position: absolute;
        right: $sd-spacing-2;
        top: $sd-spacing-2;
      }

      ui-cms-image {
        cursor: zoom-in;
      }
    }
  }

  sd-dialog {
    --width: 95vw;

    &::part(base) {
      z-index: $z-index-dialog;
    }

    &::part(panel) {
      max-height: 95vh;
    }

    picture {
      width: 100%;
      height: 100%;
    }

    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

  .moving-image-container {
    position: relative;

    .moving-image {
      width: 100%;

      &__toggle {
        position: absolute;
        right: 0;
        bottom: var(--moving-image-offset, 0);
        padding: 0;
        margin: 0;

        &::part(base) {
          border-radius: 0;
        }

        .sr-only {
          @include sr-only;
        }
      }

      &--masked {
        object-fit: cover;
        mask-image: url('data:image/svg+xml;utf8,<svg viewBox="0 0 960 800" xmlns="http://www.w3.org/2000/svg"><path d="M2.28882e-05 172.516L837.636 2.00037C893.323 -9.33587 947.26 28.6592 958.105 86.8648C959.366 93.6275 960 100.501 960 107.391V627.489L122.364 798C66.6759 809.336 12.74 771.34 1.89447 713.134C0.634414 706.372 0 699.499 0 692.609L2.28882e-05 172.516Z" fill="%23fff"/></svg>');
        mask-size: 100% 100%;
      }
    }
  }

  .video {
    margin: 0;
  }
}
